export interface MailMessage {
    // Единый формат camelCase для всего приложения
    id: string;
    senderUsername?: string;
    recipientUsername?: string;
    documentTitle: string;
    text?: string;
    status: MailStatus;
    createdAt: string;
    updatedAt: string;
    documentId: string;
    shareType?: string; // 'Send' или 'ShareAccess'
    
    // Поля для отображения, могут быть не обязательными
    senderName?: string;
    recipientName?: string;
}
  
export enum MailStatus {
    Sent = 'Sent',
    Accepted = 'Accepted',
    Declined = 'Declined',
    Unavailable = 'Unavailable',
}
  
export interface SendMailRequest {
    recipientUsername: string;
    knowledgeItemId: string;
    text?: string;
    shareType?: string; // 'Send' или 'ShareAccess'
}
  
export interface MailListResponse {
    incomingMails: MailMessage[];
    outgoingMails: MailMessage[];
    unreadCount: number;
}
  
export interface MailSignalREvent {
    type: 'NewMail' | 'MailStatusChanged';
    mailId?: string;
    mail?: MailMessage; // Используем единый тип
    status?: MailStatus;
} 